var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292893 0.292893C0.683418 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579V3.00003C7 1.34318 8.34315 3.20654e-05 10 3.20654e-05C11.6569 3.20654e-05 13 1.34318 13 3.00003V9.00003C13 9.72297 12.7443 10.3862 12.3184 10.9042L13.7367 12.3225C14.5234 11.4385 15 10.2751 15 9.00003C15 8.44775 15.4477 8.00003 16 8.00003C16.5523 8.00003 17 8.44775 17 9.00003C17 10.8279 16.2986 12.4924 15.1525 13.7383L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893ZM10.8834 9.46915C10.9578 9.32925 11 9.16957 11 9.00003V3.00003C11 2.44775 10.5523 2.00003 10 2.00003C9.44772 2.00003 9 2.44775 9 3.00003V7.58579L10.8834 9.46915Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.00003C4.55228 8.00003 5 8.44775 5 9.00003C5 11.7615 7.23858 14 10 14C10.5523 14 11 14.4477 11 15V18H13C13.5523 18 14 18.4477 14 19C14 19.5523 13.5523 20 13 20H7C6.44772 20 6 19.5523 6 19C6 18.4477 6.44772 18 7 18H9V15.9291C5.60771 15.4439 3 12.5265 3 9.00003C3 8.44775 3.44772 8.00003 4 8.00003Z",
    fill: "#F44336"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/micOff.27e4e85b271bb2ae0601d751608c2e05.svg";
export { ForwardRef as ReactComponent };